import type { PartnerPermissions } from '@/providers/Permissions.provider';

// One rule for both the Branding card's lock and the /settings/brand-settings route guard, so the
// card can never open a page the route then refuses.
export default function isBrandingLocked(permissions: PartnerPermissions): boolean {
  return (
    !permissions.WhitelabellingEnabled ||
    (!permissions.BrandingELinxEnabled &&
      !permissions.BrandingEmailEnabled &&
      !permissions.BrandingOnboardingEnabled &&
      !permissions.BrandingPortalEnabled)
  );
}
